export default function AttachTrailingSlash(url) {
    return url + (url.endsWith("/") ? "" : "/");
}